import CitySEOHead from "@/components/feature/CitySEOHead";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import PlantationHeroSection from "./components/HeroSection";
import PlantationStickyNav from "./components/StickyNav";
import PlantationProcessingTimeSection from "./components/ProcessingTimeSection";
import PlantationServicesSection from "./components/ServicesSection";
import PlantationLocalAreaSection from "./components/LocalAreaSection";
import PlantationTravelTimingSection from "./components/TravelTimingSection";
import PlantationDestinationsSection from "./components/DestinationsSection";
import PlantationTestimonialsSection from "./components/TestimonialsSection";
import PlantationAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import PlantationComparisonSection from "./components/ComparisonSection";
import PlantationMistakesSection from "./components/MistakesSection";
import PlantationHowItWorksSection from "./components/HowItWorksSection";
import PlantationFAQSection, { faqs } from "./components/FAQSection";
import PlantationHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import PlantationFinalCTA from "./components/FinalCTA";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function PlantationPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Plantation"
        state="Florida"
        stateAbbr="FL"
        route="/cities/plantation"
        title="Emergency Passport Plantation, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Plantation, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Broward County travelers."
        geoPlacename="Plantation, Florida"
        geoPosition="26.1276;-80.2331"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Florida"
        statePageRoute="/states/florida"
      />
      <PlantationHeroSection />
      <PlantationStickyNav />
      <PlantationProcessingTimeSection />
      <PlantationServicesSection />
      <PlantationLocalAreaSection />
      <PlantationTravelTimingSection />
      <PlantationDestinationsSection />
      <PlantationTestimonialsSection />
      <PlantationAcceptanceFacilitiesSection />
      <PlantationComparisonSection />
      <PlantationMistakesSection />
      <PlantationHowItWorksSection />
      <PlantationFAQSection />
      <PlantationHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/plantation" state="FL" />
      <PlantationFinalCTA />
    </div>
  );
}